<template>
<div class="index">
  <div class="wrap">
    <div class="top">
      <h3>小湃内购网，直达内部价</h3>
    </div>

    <div class="recommend-container">
      <div class="recommend-item" v-for="(item,index) in goodsList" :key="index">
        <div  class="recommend-img-wrapper" @click="getDetail(item)">
          <img :src="item.imgUrl" class="recommend-img"/>
        </div>
        <div class="recommend-info" @click="getDetail(item)">
          <div class="recommend-title">
            <span class="recommend-title-p">{{item.itemTitle}}</span>
          </div>
          <div class="recommend-price-box">
            <span class="recommend-sign">￥</span>
            <span class="recommend-price">{{item.price}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--<Loading v-if="isLoading"/>-->
</div>
</template>
<script>
import { getItemList } from 'api'
// import Loading from 'components/Loader/Loading'
export default {
  name: 'Index',
  components: {
    // Loading
  },
  data () {
    return {
      isLoading: true,
      goodsList: []
    }
  },
  mounted () {
    this.getGoodsList()
    this.isLoading = false
  },
  methods: {
    // 获取商品列表
    getGoodsList () {
      getItemList({}).then(data => {
        this.goodsList = data
      })
    },
    // 跳转详情页面
    getDetail (detail) {
      this.$router.push({
        path: '/detail'
      })
      localStorage.setItem('goodsDetailList', JSON.stringify(detail))
    }
  }
}
</script>
<style lang="scss" scoped>
.wrap{
  .top{
    background-color:#EA580F;
    text-align: center;
    color: #ffffff;
    padding: 30px 0 55px 0;
    h3{
      font-size: 14px;
      margin:0;
      padding: 0;
    }
  }
  .recommend-container{
    border-radius: 6px 6px 0 0;
    margin-top: -25px;
    padding-top: 10px;
    padding-bottom: 12px;
    display: -webkit-flex;
    display: flex;
    position: relative;
    box-sizing: border-box;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -webkit-flex-direction: row;
    flex-direction: row;
    place-content: flex-start space-between;
    flex-shrink: 0;
    overflow: hidden;
    -webkit-box-pack: justify;
    -webkit-box-lines: multiple;
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
    background: #f2f2f2;
    .recommend-item{
      position: relative;
      width: 46%;
      box-sizing: border-box;
      display: -webkit-flex;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -webkit-flex-direction: column;
      flex-direction: column;
      align-content: flex-start;
      flex-shrink: 0;
      background: #fff;
      margin-top: 10px;
      border-radius: 6px;
      overflow: hidden;
      margin-left: 2%;
      margin-right: 2%;
      .recommend-img-wrapper{
        -webkit-box-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        img.recommend-img{
          width: 100%;
          height: auto;
        }
      }
      .recommend-info{
        padding-left: 10px;
        padding-right: 9px;
        text-decoration: none;
        .recommend-title{
          margin-top: 11px;
          position: relative;
          overflow: hidden;
          line-height: 18px;
          text-overflow: ellipsis;
          min-height: 0;
          .recommend-title-p{
            font-size: 12px;
            color: #333333;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
        .recommend-price-box{
          -webkit-box-orient: horizontal;
          -webkit-box-direction: normal;
          -webkit-flex-direction: row;
          flex-direction: row;
          margin-top: 5px;
          height: 20px;
          line-height: 20px;
          text-align: right;
          .recommend-sign{
            font-size: 10px;
            color:#EA580F;
          }
          .recommend-price{
            font-size: 14px;
            line-height: 16px;
            color: #ff5500;
          }
        }
      }
    }
  }
}
</style>
